export enum PLANS_TYPE {
  PLATINUM,
  GOLD,
  SILVER,
  BRONZE,
  BRILLIANCE,
  DIAMOND,
  TITANIUM,
}
